import type { UseQueryOptions, UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';

import type { IMakeOptional, IQueryKeyFactory } from '~/helpers/types';
import type { ApiError } from '~/lib/api';
import type { IApiGetAppUserResponseBody } from '../AppsApi.types';
import { useApi } from '~/lib/api/useApi';

export type IUseAppUserQueryValues = {
  appId: string;
  userId: string;
};

export const appUserQueryKeyFactory: IQueryKeyFactory<
  IUseAppUserQueryValues
> = (values) => values && (['appUser', values.appId, values.userId] as const);

export const useAppUserQuery = (
  valuesProp?: IMakeOptional<IUseAppUserQueryValues, 'userId'>,
  options?: UseQueryOptions<IApiGetAppUserResponseBody, ApiError>,
): UseQueryResult<IApiGetAppUserResponseBody, ApiError> => {
  const api = useApi();
  const userId = valuesProp
    ? (valuesProp.userId ?? api.getCurrentUserId())
    : undefined;
  const values: IUseAppUserQueryValues | undefined =
    valuesProp && userId
      ? {
          ...valuesProp,
          userId,
        }
      : undefined;

  return useQuery({
    queryKey: appUserQueryKeyFactory(values),
    queryFn: values
      ? () => api.apps.getUser(values.appId, values.userId)
      : undefined,
    enabled: !!values,
    ...options,
  });
};
